/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NarrativeClassification } from './NarrativeClassification';
import {
    NarrativeClassificationFromJSON,
    NarrativeClassificationFromJSONTyped,
    NarrativeClassificationToJSON,
    NarrativeClassificationToJSONTyped,
} from './NarrativeClassification';

/**
 * 
 * @export
 * @interface VideoNarrativesClassificationsResponse
 */
export interface VideoNarrativesClassificationsResponse {
    /**
     * 
     * @type {string}
     * @memberof VideoNarrativesClassificationsResponse
     */
    awemeId: string;
    /**
     * 
     * @type {Array<NarrativeClassification>}
     * @memberof VideoNarrativesClassificationsResponse
     */
    narrativesClassifications: Array<NarrativeClassification>;
}

/**
 * Check if a given object implements the VideoNarrativesClassificationsResponse interface.
 */
export function instanceOfVideoNarrativesClassificationsResponse(value: object): value is VideoNarrativesClassificationsResponse {
    if (!('awemeId' in value) || value['awemeId'] === undefined) return false;
    if (!('narrativesClassifications' in value) || value['narrativesClassifications'] === undefined) return false;
    return true;
}

export function VideoNarrativesClassificationsResponseFromJSON(json: any): VideoNarrativesClassificationsResponse {
    return VideoNarrativesClassificationsResponseFromJSONTyped(json, false);
}

export function VideoNarrativesClassificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideoNarrativesClassificationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'awemeId': json['aweme_id'],
        'narrativesClassifications': ((json['narratives_classifications'] as Array<any>).map(NarrativeClassificationFromJSON)),
    };
}

export function VideoNarrativesClassificationsResponseToJSON(json: any): VideoNarrativesClassificationsResponse {
    return VideoNarrativesClassificationsResponseToJSONTyped(json, false);
}

export function VideoNarrativesClassificationsResponseToJSONTyped(value?: VideoNarrativesClassificationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aweme_id': value['awemeId'],
        'narratives_classifications': ((value['narrativesClassifications'] as Array<any>).map(NarrativeClassificationToJSON)),
    };
}

